module.exports = __webpack_public_path__ + "static/assets/6c0e73149e0bc3de27b441ef61306e52.png";